import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import pathnames from "routes/pathnames";

import api from "services/api";

import getQueryParams from "common/get-query-params";
import encodeQueryParams from "common/encode-query-params";
import serveRequestErrors from "common/serve-request-errors";

import PageClientsDto, { PageClientsTableQueryParamsDto } from "dto/pages/clients/page-clients-dto";
import ErrorResponseDto from "dto/services/error-response-dto";

import Button from "components/app-button";
import AppHeading from "components/app-heading";
import ClientsTable from "components/pages/clients/app-clients-table";

const PageClients = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [clientData, setClientData] = useState<PageClientsDto>();
	const [isFetching, setIsFetching] = useState(false);
	const memoSetSearchParams = useRef(setSearchParams);
	const queryParams = useRef(getQueryParams<PageClientsTableQueryParamsDto>(searchParams, { page: 0 }));

	const onHandleGetClients = useCallback(async () => {
		setIsFetching(true);

		try {
			const { page } = queryParams.current;

			const payload = { size: 10, page };

			const response = await api.get.client.clients(payload);

			setClientData(response.data?.data?.list);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		} finally {
			setIsFetching(false);
		}
	}, []);

	//prettier-ignore
	const handlePageChange = useCallback((page: number) => {
        queryParams.current.page = page;
 
        memoSetSearchParams.current(encodeQueryParams(queryParams.current));
 
        onHandleGetClients();
    }, [onHandleGetClients]);

	const navigateToAddNew = useCallback(() => {
		navigate(`${pathnames.client}create`);
	}, [navigate]);

	useEffect(() => {
		onHandleGetClients();
	}, [onHandleGetClients]);

	return (
		<div className="page-clients">
			<div className="clients">
				<AppHeading title="Clients">
					<AppHeading.Divider />
				</AppHeading>

				<div className="clients__button-container">
					<Button label="Add New" onClick={navigateToAddNew} />
				</div>

				{/* prettier-ignore */}
				<ClientsTable clientData={clientData?.content || []} onPageChange={handlePageChange} fetching={isFetching} paginationTable={{currentPage: clientData?.number || 0, totalPages: clientData?.totalPages || 0, totalElements: clientData?.totalElements || 0, numberOfElements: clientData?.numberOfElements || 0, tableSize: clientData?.size || 10 }} />
			</div>
		</div>
	);
};

export default PageClients;
